// import { createRouter, createWebHashHistory } from 'vue-router'
// import Home from '../views/Home.vue'

// const routes = [
//   {
//     path: '/',
//     name: 'home',
//     component: Home
//   },
//   {
//     path: '/about',
//     name: 'about',
//     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
//   },
//   {
//     path: '/technology',
//     name: 'technology',
//     component: () => import(/* webpackChunkName: "technology" */ '../views/technology.vue')
//   },
//   {
//     path: '/contactUs',
//     name: 'contactUs',
//     component: () => import(/* webpackChunkName: "contactUs" */ '../views/contactUs.vue')
//   },
//   {
//     path: '/public',
//     name: 'public',
//     component: () => import(/* webpackChunkName: "public" */ '../views/public.vue')
//   },
//   {
//     path: '/redBook',
//     name: 'redBook',
//     component: () => import(/* webpackChunkName: "redBook" */ '../views/redBook.vue')
//   },
//   {
//     path: '/medium',
//     name: 'medium',
//     component: () => import(/* webpackChunkName: "medium" */ '../views/medium.vue')
//   }
// ]

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })

// export default router

import { createRouter, createWebHashHistory } from 'vue-router'
import routerM from './routerM'
import routerPC from './routerPC'


const ISMOBILE = function () {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};
 
const router = createRouter({
  history: createWebHashHistory(),
  routes: ISMOBILE() ? routerM : routerPC,
})

export default router

